import {onCheckoutUpdate} from '../checkout';
import {type PeachPayCheckoutData} from '../types';
import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {billingDetails} from './stripe';
import {type Stripe, type StripeElements, type StripeIdealBankElement} from '@stripe/stripe-js';

declare const peachpay_checkout_data: PeachPayCheckoutData;

class StripeIdealPayment extends AbstractStripePayment {
	private readonly $idealElement: StripeIdealBankElement;

	constructor(stripe: Stripe, elements: StripeElements) {
		super(stripe, elements);

		this.$idealElement = (elements).create('idealBank');
		onCheckoutUpdate(() => {
			try {
				this.$idealElement.mount('#pp-stripe-ideal-element');
			} catch { }
		});
		try {
			this.$idealElement.mount('#pp-stripe-ideal-element');
		} catch { }
	}

	public gatewayId() {
		return 'peachpay_stripe_ideal';
	}

	public async tokenize(): Promise<TokenResult> {
		const billing_details = billingDetails();

		if (peachpay_checkout_data.page.is_order_pay && peachpay_checkout_data.order_pay_details) {
			billing_details.name = peachpay_checkout_data.order_pay_details.billing_first_name + ' ' + peachpay_checkout_data.order_pay_details.billing_last_name;
			billing_details.email = peachpay_checkout_data.order_pay_details.billing_email;
		}

		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'ideal',
			ideal: this.$idealElement,
			billing_details,
		});

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Payment failed to tokenize.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmIdealPayment(clientSecret, {
			return_url: intermediateURL,
		});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {StripeIdealPayment};
